import { render, staticRenderFns } from "./Step1BasicInfo.vue?vue&type=template&id=5cf9e367&scoped=true&"
import script from "./Step1BasicInfo.vue?vue&type=script&lang=js&"
export * from "./Step1BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./Step1BasicInfo.vue?vue&type=style&index=0&id=5cf9e367&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf9e367",
  null
  
)

export default component.exports